module.exports = __webpack_public_path__ + "static/media/Turkmenistan.36bd38e6.png";